

export default function DoubleMattressIcon({ className }) {
    return <svg className={className} width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.4263 20.6287H16.0846C16.5794 20.6287 16.9805 20.2276 16.9805 19.7328L16.9805 2.17449C16.9805 1.67974 16.5794 1.27866 16.0846 1.27866H11.4263C10.9315 1.27866 10.5305 1.67974 10.5305 2.1745L10.5305 19.7328C10.5305 20.2276 10.9315 20.6287 11.4263 20.6287Z" stroke="currentColor" strokeWidth="0.716667" />
        <path d="M4.97708 20.6287H9.63542C10.1302 20.6287 10.5312 20.2276 10.5312 19.7328L10.5313 2.17449C10.5313 1.67974 10.1302 1.27866 9.63542 1.27866H4.97708C4.48233 1.27866 4.08125 1.67974 4.08125 2.1745L4.08125 19.7328C4.08125 20.2276 4.48233 20.6287 4.97708 20.6287Z" stroke="currentCOlor" strokeWidth="0.716667" />
    </svg>


}